import { useTranslation } from 'react-i18next';
import { STATUS_OPTIONS } from './helpers';

const FilterBar = ({ filters, onChange, onApply, onClear, eventTypes = [] }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white border border-[#E5E7EB] rounded-xl p-4 mb-4">
      {/* <h3 className="text-[11px] font-semibold text-[#7989A0] uppercase tracking-wide mb-3">
        {t('admin.reporting.webhooks.filters.label')}
      </h3> */}

      <div className="flex flex-wrap gap-3 items-end">
        {/* Date From */}
        <div className="flex flex-col gap-1">
          <label className="text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide">
            {t('admin.reporting.webhooks.filters.from')}
          </label>
          <input
            type="date"
            value={filters.from}
            onChange={(e) => onChange('from', e.target.value)}
            className="h-[34px] border border-[#D7DEE8] rounded-lg px-3 py-0 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#334155]/20"
          />
        </div>

        {/* Date To */}
        <div className="flex flex-col gap-1">
          <label className="text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide">
            {t('admin.reporting.webhooks.filters.to')}
          </label>
          <input
            type="date"
            value={filters.to}
            onChange={(e) => onChange('to', e.target.value)}
            className="h-[34px] border border-[#D7DEE8] rounded-lg px-3 py-0 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#334155]/20"
          />
        </div>

        {/* Event Type */}
        <div className="flex flex-col gap-1">
          <label className="text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide">
            {t('admin.reporting.webhooks.filters.eventType')}
          </label>
          <select
            value={filters.eventType}
            onChange={(e) => onChange('eventType', e.target.value)}
            className="h-[34px] border border-[#D7DEE8] rounded-lg px-3 py-0 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#334155]/20"
          >
            {['all', ...eventTypes].map((opt) => (
              <option key={opt} value={opt}>
                {opt === 'all'
                  ? t('admin.reporting.webhooks.filters.allTypes')
                  : t(`subscriptions.admin.subscribers.detail.eventTypes.${opt}`, { defaultValue: opt })}
              </option>
            ))}
          </select>
        </div>

        {/* Status */}
        <div className="flex flex-col gap-1">
          <label className="text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide">
            {t('admin.reporting.webhooks.filters.status')}
          </label>
          <select
            value={filters.status}
            onChange={(e) => onChange('status', e.target.value)}
            className="h-[34px] border border-[#D7DEE8] rounded-lg px-3 py-0 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#334155]/20"
          >
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt === 'all'
                  ? t('admin.reporting.webhooks.filters.allStatuses')
                  : t(`admin.reporting.webhooks.status.${opt}`, { defaultValue: opt.charAt(0).toUpperCase() + opt.slice(1) })}
              </option>
            ))}
          </select>
        </div>

        {/* Subscription Plan */}
        <div className="flex flex-col gap-1">
          <label className="text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide">
            {t('admin.reporting.webhooks.filters.subscriptionPlan', { defaultValue: 'Subscription Plan' })}
          </label>
          <div className="relative flex items-center">
            <input
              type="text"
              value={filters.subscriptionPlanName}
              onChange={(e) => onChange('subscriptionPlanName', e.target.value)}
              placeholder="e.g. Elite Supporter"
              className="h-[34px] border border-[#D7DEE8] rounded-lg px-3 py-0 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#334155]/20 pr-7 w-[180px]"
            />
            {filters.subscriptionPlanName && (
              <button
                type="button"
                onClick={() => onChange('subscriptionPlanName', '')}
                className="absolute right-2 text-[#94A3B8] hover:text-[#475569] transition-colors"
                aria-label="Clear subscription plan filter"
              >
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex gap-2 items-end">
          <button
            onClick={onApply}
            className="h-[34px] px-4 rounded-lg bg-[#334155] text-white text-[13px] font-semibold hover:bg-[#1E293B] transition-colors"
          >
            {t('admin.reporting.webhooks.filters.apply')}
          </button>
          <button
            onClick={onClear}
            className="h-[34px] px-4 rounded-lg border border-[#D7DEE8] text-[13px] text-[#64748B] font-medium hover:bg-[#F1F5F9] transition-colors"
          >
            {t('admin.reporting.webhooks.filters.clear')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
